export enum GlistSkin {
    SKIN_MODERN = 'skin-modern',
    SKIN_CARDS  = 'skin-cards'
}

// default - signle non sticky header
// sticky - signle sticky header
// multiple - not in use at the moment each group has it's own header just for future (!)
// hidden - no header - not event group by (!)
export enum GlistHeaderMode {
    HIDDEN      = 'hidden',
    DEFAULT     = 'default',
    STICKY      = 'sticky',
    MULTIPLE    = 'multiple',
}
